.kj{pointer-events:auto;}